import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const PHRASES = [
  "Machine ! Continue comme ca !",
  "Tu geres comme un chef !",
  "Boufi power !",
  "Parfait, on est au top !",
  "Rien ne t'arrete !",
  "C'est du propre !",
  "Efficace, rapide, Boufi !",
  "Un de plus, on avance !",
  "La team Boufi en action !",
  "Bravo, c'est enregistre !",
  "Cookie apres cookie, on gagne !",
  "C'est ca le flow Boufi !",
  "Allez, on lache rien !",
  "Top chrono, bien joue !",
  "Le reseau avance grace a toi !",
];

const EMOJI_SETS = {
  fire: ['&#x1F525;', '&#x2B50;', '&#x1F4AA;', '&#x1F389;', '&#x1F680;'],
  cookie: ['&#x1F36A;', '&#x2B50;', '&#x1F525;', '&#x1F389;', '&#x1F38A;'],
  save: ['&#x2705;', '&#x1F4BE;', '&#x2B50;', '&#x1F525;', '&#x1F44F;'],
  stock: ['&#x1F4E6;', '&#x2B50;', '&#x1F525;', '&#x1F680;', '&#x1F4AA;'],
};

const CelebrationContext = createContext(null);

export function useCelebration() {
  return useContext(CelebrationContext);
}

function Particle({ emoji, style }) {
  return (
    <span
      className="celebration-particle"
      style={style}
      dangerouslySetInnerHTML={{ __html: emoji }}
    />
  );
}

export function CelebrationProvider({ children }) {
  const [celebration, setCelebration] = useState(null);

  const celebrate = useCallback((type = 'fire') => {
    const phrase = PHRASES[Math.floor(Math.random() * PHRASES.length)];
    const emojis = EMOJI_SETS[type] || EMOJI_SETS.fire;
    setCelebration({ phrase, emojis, id: Date.now() });
  }, []);

  useEffect(() => {
    if (celebration) {
      const timer = setTimeout(() => setCelebration(null), 2800);
      return () => clearTimeout(timer);
    }
  }, [celebration]);

  const particles = celebration ? Array.from({ length: 18 }, (_, i) => {
    const emoji = celebration.emojis[i % celebration.emojis.length];
    const left = Math.random() * 100;
    const delay = Math.random() * 0.6;
    const size = 18 + Math.random() * 16;
    const duration = 1.2 + Math.random() * 0.8;
    return (
      <Particle
        key={`${celebration.id}-${i}`}
        emoji={emoji}
        style={{
          left: `${left}%`,
          animationDelay: `${delay}s`,
          animationDuration: `${duration}s`,
          fontSize: `${size}px`,
        }}
      />
    );
  }) : null;

  return (
    <CelebrationContext.Provider value={celebrate}>
      {children}
      {celebration && (
        <div className="celebration-overlay" key={celebration.id}>
          {particles}
          <div className="celebration-phrase">
            <span className="celebration-phrase-inner">
              {celebration.phrase}
            </span>
          </div>
        </div>
      )}
    </CelebrationContext.Provider>
  );
}
